/*
 * Bundle picker (snippets/quantity-break.liquid).
 * - The tier named by the block's pre-select rule starts selected ("badge" = the first tier that
 *   carries a badge, "1"-"4" = that tier, "none" = nothing until the shopper picks).
 * - The price of each tier follows the lengths chosen for its garlands.
 * - Add to cart posts exactly one line: the variant for the tier + lengths, quantity 1,
 *   with one "Strand #n" property per garland. With no bundle chosen it selects the first tier
 *   (the one the header price already shows) and adds that, so the button is never a dead end.
 * - Keeps the header price, the add-to-cart button and the sticky bar in step. The button shows
 *   one price: "<label> - <price of the chosen bundle>". With nothing chosen the header price
 *   follows the first tier, so it never disagrees with the rows under it.
 * - Generic mode (cfg.generic, products without length metafields): the options after the pack
 *   (Version, Colour, ...) are pill rows shared by every tier. The variant is pack + pills; tier
 *   prices follow the pills and the gallery jumps to that variant's image.
 * - Per-item option (cfg.itemOptionPos, from the product metafield custom.per_item_option): that
 *   option reuses the length machinery — "set all" pills + one dropdown per item inside the tier.
 *   The variant takes item #1's value; every item's value goes out as a line-item property.
 */
(function () {
  if (window.MMBundle) { window.MMBundle.scan(); return; }

  var pickers = [];

  function parseList(raw) {
    if (!raw) return [];
    if (Array.isArray(raw)) return raw.map(String);
    var t = String(raw).trim();
    if (t.charAt(0) === '[') { try { return JSON.parse(t).map(String); } catch (e) { /* fall through */ } }
    return t.split(',').map(function (x) { return x.trim(); }).filter(Boolean);
  }

  function countIn(s) {
    var m = /^(\d+)/.exec(String(s == null ? '' : s).trim());
    return m ? parseInt(m[1], 10) : 0;
  }

  function esc(s) { return String(s).replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }

  function Picker(root) {
    var self = this;
    var dataEl = root.querySelector('script[data-mm-qb-data]');
    this.root = root;
    this.cfg = {};
    try { this.cfg = JSON.parse(dataEl ? dataEl.textContent : '{}'); } catch (e) { this.cfg = {}; }
    this.cfg.variants = this.cfg.variants || [];
    this.lengths = parseList(this.cfg.lengths);
    this.longs = {};
    parseList(this.cfg.longLengths).forEach(function (x) { self.longs[x.toLowerCase()] = true; });
    this.chosen = {};
    this.selected = 0;
    this.pill = this.lengths[0] || null;
    this.generic = !!this.cfg.generic;
    this.opts = {};
    this.grid = this.buildGrid();

    root.querySelectorAll('[data-mm-qb-opt]').forEach(function (group) {
      var pos = parseInt(group.getAttribute('data-mm-qb-opt'), 10) || 0;
      var pressed = group.querySelector('[data-mm-qb-optval][aria-pressed="true"]') || group.querySelector('[data-mm-qb-optval]');
      if (pos && pressed) self.opts[pos] = pressed.getAttribute('data-mm-qb-optval');
      group.querySelectorAll('[data-mm-qb-optval]').forEach(function (btn) {
        btn.addEventListener('click', function () { self.setOpt(pos, btn.getAttribute('data-mm-qb-optval')); });
      });
    });

    this.tiers().forEach(function (tier) {
      var t = self.tierOf(tier);
      var n = parseInt(tier.getAttribute('data-strands'), 10) || 0;
      self.chosen[t] = [];
      for (var i = 0; i < n; i++) self.chosen[t][i] = self.lengths[0] || '';
      var radio = tier.querySelector('.mm-qb__radio');
      if (radio) {
        radio.checked = false;
        radio.addEventListener('change', function () { if (radio.checked) self.select(t); });
      }
      tier.querySelectorAll('[data-mm-qb-select]').forEach(function (sel) {
        var idx = parseInt(sel.getAttribute('data-mm-qb-select'), 10) || 0;
        sel.value = self.chosen[t][idx] || sel.value;
        sel.addEventListener('change', function () {
          self.chosen[t][idx] = sel.value;
          self.refreshTier(tier);
          self.refreshPills();
          /* picking a colour inside a bundle chooses that bundle, so the gallery and the price
             always follow the dropdown the shopper just used */
          if (self.selected !== t) { self.select(t); return; }
          self.publish();
          self.showImage();
        });
      });
    });

    root.querySelectorAll('[data-mm-qb-pill]').forEach(function (btn) {
      btn.addEventListener('click', function () { self.setAll(btn.getAttribute('data-mm-qb-pill')); });
    });

    this.tiers().forEach(function (tier) { self.refreshTier(tier); });
    this.refreshPills();
    var first = this.preselectTier();
    if (first) this.select(first); else this.publish();
  }

  /* which tier starts selected: cfg.preselect = "badge" | "none" | "1".."4" */
  Picker.prototype.preselectTier = function () {
    var rule = String(this.cfg.preselect == null ? 'badge' : this.cfg.preselect).toLowerCase();
    var tiers = this.tiers(), self = this;
    if (rule === 'none' || !tiers.length) return 0;
    if (rule === 'badge') {
      for (var i = 0; i < tiers.length; i++) if (tiers[i].querySelector('.mm-qb__badge')) return self.tierOf(tiers[i]);
      return 0;
    }
    var n = parseInt(rule, 10);
    return n && this.tierEl(n) ? n : 0;
  };

  Picker.prototype.tiers = function () {
    return Array.prototype.slice.call(this.root.querySelectorAll('[data-mm-qb-tier]'));
  };

  Picker.prototype.tierOf = function (el) { return parseInt(el.getAttribute('data-mm-qb-tier'), 10) || 0; };

  Picker.prototype.tierEl = function (t) { return this.root.querySelector('[data-mm-qb-tier="' + t + '"]'); };

  /* pack value -> number of long strands -> variant, from options like "4 Garlands" / "3× 6ft + 1× 9ft" */
  Picker.prototype.buildGrid = function () {
    var re = new RegExp('(\\d+)\\s*[×x]\\s*' + esc(this.cfg.longToken || '9ft'), 'i');
    var g = {};
    this.cfg.variants.forEach(function (v) {
      var m = re.exec(v.o2 || '');
      var nl = m ? parseInt(m[1], 10) : 0;
      g[v.o1] = g[v.o1] || {};
      if (!g[v.o1][nl]) g[v.o1][nl] = v;
    });
    return g;
  };

  Picker.prototype.variantFor = function (t) {
    var tier = this.tierEl(t);
    if (!tier) return null;
    if (this.generic) {
      var pack = tier.getAttribute('data-pack'), o = Object.assign({}, this.opts), hit = null;
      var ip = parseInt(this.cfg.itemOptionPos, 10) || 0;
      if (ip) { var picks = this.chosen[t] || []; o[ip] = picks[0] || this.pill || null; }
      this.cfg.variants.some(function (v) {
        if (v.o1 !== pack) return false;
        if (o[2] != null && v.o2 !== o[2]) return false;
        if (o[3] != null && v.o3 !== o[3]) return false;
        hit = v; return true;
      });
      return hit;
    }
    var row = this.grid[tier.getAttribute('data-pack')];
    if (!row) return null;
    var picks = this.chosen[t] || [], n = 0, self = this;
    picks.forEach(function (p) { if (self.longs[String(p).toLowerCase()]) n++; });
    return row[n] || row[0] || null;
  };

  Picker.prototype.money = function (cents) {
    var amount = (cents / 100).toFixed(2);
    var f = String(this.cfg.moneyFormat || '${{amount}}').replace(/<[^>]+>/g, '');
    if (f.indexOf('{{amount_no_decimals}}') !== -1) return f.replace('{{amount_no_decimals}}', String(Math.round(cents / 100)));
    if (f.indexOf('{{amount_with_comma_separator}}') !== -1) return f.replace('{{amount_with_comma_separator}}', amount.replace('.', ','));
    return f.replace(/\{\{\s*amount[^}]*\}\}/, amount);
  };

  Picker.prototype.refreshTier = function (tier) {
    var v = this.variantFor(this.tierOf(tier));
    if (!v) return;
    var price = tier.querySelector('[data-mm-qb-price]');
    var compare = tier.querySelector('[data-mm-qb-compare]');
    var radio = tier.querySelector('.mm-qb__radio');
    if (price) price.textContent = this.money(v.price);
    if (compare) compare.textContent = v.compare > v.price ? this.money(v.compare) : '';
    if (radio) radio.setAttribute('data-price', String(v.price));
  };

  /* the length every visible strand shares, or null when they differ */
  Picker.prototype.common = function () {
    var t = this.selected, picks = t ? (this.chosen[t] || []) : null;
    if (!picks || !picks.length) return this.pill;
    for (var i = 1; i < picks.length; i++) if (picks[i] !== picks[0]) return null;
    return picks[0];
  };

  Picker.prototype.refreshPills = function () {
    var cur = this.common();
    this.root.querySelectorAll('[data-mm-qb-pill]').forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-mm-qb-pill') === cur));
    });
    var label = this.root.querySelector('[data-mm-qb-length-label]');
    if (label) label.textContent = (this.cfg.lengthLabel || 'Length') + ' - ' + (cur == null ? 'Mixed' : cur);
  };

  Picker.prototype.setAll = function (val) {
    var self = this;
    this.pill = val;
    Object.keys(this.chosen).forEach(function (t) {
      self.chosen[t] = self.chosen[t].map(function () { return val; });
    });
    this.root.querySelectorAll('[data-mm-qb-select]').forEach(function (sel) { sel.value = val; });
    this.tiers().forEach(function (tier) { self.refreshTier(tier); });
    this.refreshPills();
    this.publish();
    this.showImage();
  };

  /* generic mode: one of the shared option pills (Version, Colour, ...) was chosen */
  Picker.prototype.setOpt = function (pos, val) {
    var self = this;
    this.opts[pos] = val;
    var group = this.root.querySelector('[data-mm-qb-opt="' + pos + '"]');
    if (group) {
      group.querySelectorAll('[data-mm-qb-optval]').forEach(function (b) {
        b.setAttribute('aria-pressed', String(b.getAttribute('data-mm-qb-optval') === val));
      });
      var label = group.querySelector('[data-mm-qb-opt-value]');
      if (label) label.textContent = val;
    }
    this.tiers().forEach(function (tier) { self.refreshTier(tier); });
    this.publish();
    this.showImage();
  };

  /* jump the gallery to the current variant's image (thumbnails carry data-media-id) */
  Picker.prototype.showImage = function () {
    var first = this.tiers()[0];
    var v = this.current() || (first ? this.variantFor(this.tierOf(first)) : null);
    if (!v || !v.media) return;
    if (this.lastMedia === v.media) return;
    this.lastMedia = v.media;
    if (typeof window.mmGalleryShowMedia === 'function') { window.mmGalleryShowMedia(v.media); return; }
    var section = this.root.closest('.shopify-section') || document;
    var thumb = section.querySelector('.shop-thumbnail[data-media-id="' + v.media + '"]');
    if (!thumb) return;
    var idx = parseInt(thumb.getAttribute('data-index'), 10);
    if (!isNaN(idx) && typeof window.changeImage === 'function') { try { window.changeImage(idx); return; } catch (e) { /* fall through */ } }
    thumb.click();
  };

  Picker.prototype.select = function (t) {
    this.selected = t;
    this.tiers().forEach(function (tier) {
      var on = parseInt(tier.getAttribute('data-mm-qb-tier'), 10) === t;
      tier.classList.toggle('is-selected', on);
      var radio = tier.querySelector('.mm-qb__radio');
      if (radio && radio.checked !== on) radio.checked = on;
      var strands = tier.querySelector('[data-mm-qb-strands]');
      if (strands) strands.hidden = !on;
    });
    var nudge = this.root.querySelector('[data-mm-qb-nudge]');
    if (nudge) nudge.hidden = true;
    this.refreshPills();
    this.publish();
    this.showImage();
  };

  /* nothing chosen yet: choose the first tier (the one the header price already shows) so the
     add-to-cart button is never a dead end. Returns the tier number, or 0 when there are no tiers. */
  Picker.prototype.selectFirst = function () {
    var first = this.tiers()[0];
    if (!first) return 0;
    var t = this.tierOf(first);
    if (t) this.select(t);
    return t;
  };

  Picker.prototype.current = function () {
    return this.selected ? this.variantFor(this.selected) : null;
  };

  Picker.prototype.properties = function () {
    var t = this.selected, picks = this.chosen[t] || [], out = {}, prefix = this.cfg.propertyPrefix || 'Strand';
    if (!this.lengths.length || !picks.length) return null;
    picks.forEach(function (p, i) { out[prefix + ' #' + (i + 1)] = p; });
    return out;
  };

  Picker.prototype.nudge = function () {
    var el = this.root.querySelector('[data-mm-qb-nudge]');
    if (el) el.hidden = false;
    var top = this.root.getBoundingClientRect().top + window.pageYOffset - 120;
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  };

  /* header price, add-to-cart label, sticky bar */
  Picker.prototype.publish = function () {
    var v = this.current();
    var detail = {
      productId: this.cfg.productId,
      tier: this.selected,
      variant: v,
      price: v ? this.money(v.price) : '',
      compare: v && v.compare > v.price ? this.money(v.compare) : '',
      savePercent: v && v.compare > v.price ? Math.round((v.compare - v.price) / v.compare * 100) : 0,
      length: this.common(),
      lengths: this.lengths,
      options: this.generic ? Object.assign({}, this.opts) : null
    };
    this.last = detail;

    var section = this.root.closest('.shopify-section') || document;
    /* header price: the chosen bundle, or the first tier while nothing is chosen */
    var firstTier = this.tiers()[0];
    var shown = v || (firstTier ? this.variantFor(this.tierOf(firstTier)) : null);
    if (shown) {
      var priceEl = section.querySelector('.shop-product-price-block');
      var compareEl = section.querySelector('.shop-compare-price');
      if (priceEl) priceEl.textContent = this.money(shown.price);
      if (compareEl) compareEl.textContent = shown.compare > shown.price ? this.money(shown.compare) : '';
    }
    /* button: the plain label (data-mm-label, written by snippets/buy-buttons.liquid) plus one price */
    section.querySelectorAll('.shop-add-to-cart-button .button-text, .product-form__submit .button__text').forEach(function (el) {
      if (!el.hasAttribute('data-mm-label')) el.setAttribute('data-mm-label', el.textContent.replace(/\s*-\s*[^-]*\d[\s\S]*$/, '').trim());
      var base = el.getAttribute('data-mm-label');
      var text = v ? base + ' - ' + detail.price : base;
      if (el.textContent !== text) el.textContent = text;
    });

    document.dispatchEvent(new CustomEvent('mm:bundle-change', { detail: detail }));
  };

  function pickerFor(el) {
    var section = el.closest('.shopify-section');
    for (var i = 0; i < pickers.length; i++) {
      if (!document.contains(pickers[i].root)) continue;
      if (!section || section.contains(pickers[i].root)) return pickers[i];
    }
    return null;
  }

  function owns(p, id) {
    return p.cfg.variants.some(function (v) { return v.id === id; });
  }

  /* ---------- add to cart: one path ---------- */
  var adding = false;
  var nativeFetch = window.fetch;

  function showError(form, text) {
    var pf = form.closest('product-form') || form.parentNode;
    var wrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    var span = wrap && wrap.querySelector('.product-form__error-message');
    if (wrap && span) { span.textContent = text; wrap.removeAttribute('hidden'); }
  }

  function addToCart(p, form) {
    var v = p.current();
    if (!v || adding) return;
    adding = true;
    var btn = form.querySelector('[type="submit"]');
    var spin = btn && btn.querySelector('.loading__spinner');
    if (btn) { btn.classList.add('loading'); btn.setAttribute('aria-disabled', 'true'); }
    if (spin) spin.classList.remove('hidden');
    var pf = form.closest('product-form') || form.parentNode;
    var errWrap = pf && pf.querySelector('.product-form__error-message-wrapper');
    if (errWrap) errWrap.setAttribute('hidden', '');

    var line = { id: v.id, quantity: 1 };
    var props = p.properties();
    if (props) line.properties = props;
    var body = { items: [line] };
    var drawer = document.querySelector('cart-drawer');
    if (drawer && typeof drawer.renderContents === 'function') {
      body.sections = 'cart-drawer,cart-icon-bubble';
      body.sections_url = window.location.pathname;
    }
    var url = p.cfg.cartAddUrl || '/cart/add';
    if (!/\.js$/.test(url)) url += '.js';

    nativeFetch.call(window, url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify(body)
    })
      .then(function (r) { return r.json(); })
      .then(function (res) {
        if (res && res.status) { showError(form, res.description || res.message || 'Could not add to cart'); return; }
        if (drawer && res && res.sections) {
          /* The drawer is rendered with "is-empty" when the cart starts empty, and that class hides the
             item list. product-form.js removes it; this path replaces product-form.js, so do it here. */
          drawer.classList.remove('is-empty');
          try { drawer.renderContents(res); return; } catch (e) { /* fall back to the cart page */ }
        }
        window.location.href = p.cfg.cartUrl || '/cart';
      })
      .catch(function () { showError(form, 'Could not add to cart. Please try again.'); })
      .then(function () {
        adding = false;
        if (btn) { btn.classList.remove('loading'); btn.removeAttribute('aria-disabled'); }
        if (spin) spin.classList.add('hidden');
      });
  }

  document.addEventListener('submit', function (ev) {
    var form = ev.target;
    if (!form || !form.matches || !form.matches('form[action*="/cart/add"]')) return;
    var idEl = form.querySelector('[name="id"]');
    var id = idEl ? parseInt(idEl.value, 10) : 0;
    var p = pickerFor(form);
    if (!p || !owns(p, id)) return;
    ev.preventDefault();
    ev.stopImmediatePropagation();
    if (!p.selected && !p.selectFirst()) { p.nudge(); return; }
    addToCart(p, form);
  }, true);

  /* safety net: any other script posting this product to the cart gets the chosen bundle */
  window.fetch = function (url, opts) {
    try {
      var u = typeof url === 'string' ? url : (url && url.url) || '';
      if (u.indexOf('/cart/add') !== -1 && opts && opts.body) {
        var p = null;
        for (var i = 0; i < pickers.length; i++) { if (pickers[i].selected && document.contains(pickers[i].root)) { p = pickers[i]; break; } }
        var v = p && p.current();
        if (v) {
          var props = p.properties();
          if (typeof FormData !== 'undefined' && opts.body instanceof FormData) {
            var fid = parseInt(opts.body.get('id'), 10);
            if (owns(p, fid)) {
              opts.body.set('id', String(v.id));
              opts.body.set('quantity', '1');
              if (props) Object.keys(props).forEach(function (k) { opts.body.set('properties[' + k + ']', props[k]); });
            }
          } else if (typeof opts.body === 'string') {
            var payload = JSON.parse(opts.body);
            if (payload && Array.isArray(payload.items) && payload.items.some(function (it) { return owns(p, it.id); })) {
              var line = { id: v.id, quantity: 1 };
              if (props) line.properties = props;
              payload.items = [line].concat(payload.items.filter(function (it) { return !owns(p, it.id); }));
              opts = Object.assign({}, opts, { body: JSON.stringify(payload) });
            }
          }
        }
      }
    } catch (e) { /* leave the request untouched */ }
    return nativeFetch.apply(this, [url, opts]);
  };

  function scan() {
    pickers = pickers.filter(function (p) { return document.contains(p.root); });
    document.querySelectorAll('[data-mm-qb]').forEach(function (root) {
      if (root.__mmPicker) return;
      root.__mmPicker = new Picker(root);
      pickers.push(root.__mmPicker);
    });
  }

  window.MMBundle = {
    scan: scan,
    get: function () {
      for (var i = 0; i < pickers.length; i++) if (document.contains(pickers[i].root)) return pickers[i];
      return null;
    },
    /* sticky bar button: add the chosen bundle, or take the shopper to the bundles */
    buy: function (ev) {
      if (ev) ev.preventDefault();
      var p = window.MMBundle.get();
      if (!p) { window.scrollTo({ top: 0, behavior: 'smooth' }); return; }
      if (!p.selected && !p.selectFirst()) { p.nudge(); return; }
      var section = p.root.closest('.shopify-section') || document;
      var form = section.querySelector('form[action*="/cart/add"]');
      if (form) addToCart(p, form); else p.nudge();
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan); else scan();
  document.addEventListener('shopify:section:load', scan);

  /* back/forward cache restores old radio states; start clean again */
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    pickers.forEach(function (p) {
      p.selected = 0;
      p.tiers().forEach(function (tier) {
        tier.classList.remove('is-selected');
        var r = tier.querySelector('.mm-qb__radio'); if (r) r.checked = false;
        var s = tier.querySelector('[data-mm-qb-strands]'); if (s) s.hidden = true;
      });
      var first = p.preselectTier();
      if (first) p.select(first); else p.publish();
    });
  });
})();